<template>
    <div class="text-center">This integration is being reviewed, you will be notified as soon as it's done</div>
</template>

<script>
    export default {}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// pendingActivation.vue?7b0ef076